/** Явная классификация организации участника; роль сама по себе не открывает внешний кабинет. */
export const EXTERNAL_PROFILES = {
  supplier: 'Поставщик',
  subcontractor: 'Субподрядчик',
  customer: 'Заказчик',
  designer: 'Проектировщик',
  inspector: 'Инспектор',
} as const;
export type ExternalProfile = keyof typeof EXTERNAL_PROFILES;

/** Верхняя граница прав. Выданная роль может только сузить этот набор. */
export const EXTERNAL_PERMISSIONS: Record<ExternalProfile, readonly string[]> = {
  supplier: ['contracts.view', 'contracts.docs', 'procurement.view'],
  subcontractor: [
    'project.view',
    'schedule.view',
    'site.view',
    'site.report',
    'supervision.view',
    'supervision.respond',
    'contracts.view',
    'contracts.docs',
    'procurement.view',
  ],
  customer: ['project.view', 'schedule.view', 'site.view', 'changes.view'],
  designer: [
    'project.view',
    'psd.view',
    'psd.upload',
    'supervision.view',
    'supervision.issue',
    'supervision.respond',
  ],
  inspector: [
    'project.view',
    'schedule.view',
    'site.view',
    'psd.view',
    'supervision.view',
    'supervision.issue',
    'supervision.respond',
  ],
};
